export default __webpack_public_path__ + "static/cms-0-b9e9f3b520d3a39cefc8aaac0be094ed.png";